import { cva } from 'class-variance-authority';

import { legacyVariants } from './_deprecated/old-typography';

export const textVariants = cva('', {
  variants: {
    variant: {
      ...legacyVariants,
      // text-2xl-leading-none-black
      'text-2xl/leading-none/black':
        'font-nista-grotesk text-2xl leading-none font-black tracking-wider',
      // text-2xl-leading-none-bold
      'text-2xl/leading-none/bold':
        'font-nista-grotesk text-2xl leading-none font-bold tracking-wider',
      // text-2xl-leading-none-extrabold
      'text-2xl/leading-none/extrabold':
        'font-nista-grotesk text-2xl leading-none font-extrabold tracking-wider',
      // text-2xl-leading-none-extralight
      'text-2xl/leading-none/extralight':
        'font-nista-grotesk text-2xl leading-none font-thin tracking-wider',
      // text-2xl-leading-none-italic
      'text-2xl/leading-none/italic':
        'font-nista-grotesk text-2xl leading-none font-normal tracking-wider italic',
      // text-2xl-leading-none-light
      'text-2xl/leading-none/light':
        'font-nista-grotesk text-2xl leading-none font-light tracking-wider',
      // text-2xl-leading-none-medium
      'text-2xl/leading-none/medium':
        'font-nista-grotesk text-2xl leading-none font-medium tracking-wider',
      // text-2xl-leading-none-normal
      'text-2xl/leading-none/normal':
        'font-nista-grotesk text-2xl leading-none font-normal tracking-wider',
      // text-2xl-leading-none-semibold
      'text-2xl/leading-none/semibold':
        'font-nista-grotesk text-2xl leading-none font-bold tracking-wider',
      // text-2xl-leading-none-strikethrough
      'text-2xl/leading-none/strikethrough':
        'font-nista-grotesk text-2xl leading-none font-normal tracking-wider line-through',
      // text-2xl-leading-none-thin
      'text-2xl/leading-none/thin':
        'font-nista-grotesk text-2xl leading-none font-thin tracking-wider',
      // text-2xl-leading-none-underlined
      'text-2xl/leading-none/underlined':
        'font-nista-grotesk text-2xl leading-none font-normal tracking-wider underline',
      // text-2xl-leading-normal-black
      'text-2xl/leading-normal/black':
        'font-nista-grotesk leading-2xl text-2xl font-black tracking-wide',
      // text-2xl-leading-normal-bold
      'text-2xl/leading-normal/bold':
        'font-nista-grotesk leading-2xl text-2xl font-bold tracking-wide',
      // text-2xl-leading-normal-extrabold
      'text-2xl/leading-normal/extrabold':
        'font-nista-grotesk leading-2xl text-2xl font-extrabold tracking-wide',
      // text-2xl-leading-normal-extralight
      'text-2xl/leading-normal/extralight':
        'font-nista-grotesk leading-2xl text-2xl font-thin tracking-wide',
      // text-2xl-leading-normal-italic
      'text-2xl/leading-normal/italic':
        'font-nista-grotesk leading-2xl text-2xl font-normal tracking-wide italic',
      // text-2xl-leading-normal-light
      'text-2xl/leading-normal/light':
        'font-nista-grotesk leading-2xl text-2xl font-light tracking-wide',
      // text-2xl-leading-normal-medium
      'text-2xl/leading-normal/medium':
        'font-nista-grotesk leading-2xl text-2xl font-medium tracking-wide',
      // text-2xl-leading-normal-normal
      'text-2xl/leading-normal/normal':
        'font-nista-grotesk leading-2xl text-2xl font-normal tracking-wide',
      // text-2xl-leading-normal-semibold
      'text-2xl/leading-normal/semibold':
        'font-nista-grotesk leading-2xl text-2xl font-bold tracking-wide',
      // text-2xl-leading-normal-strikethrough
      'text-2xl/leading-normal/strikethrough':
        'font-nista-grotesk leading-2xl text-2xl font-normal tracking-wide line-through',
      // text-2xl-leading-normal-thin
      'text-2xl/leading-normal/thin':
        'font-nista-grotesk leading-2xl text-2xl font-thin tracking-wide',
      // text-2xl-leading-normal-underlined
      'text-2xl/leading-normal/underlined':
        'font-nista-grotesk leading-2xl text-2xl font-normal tracking-wide underline',
      // text-2xs-leading-none-black
      'text-2xs/leading-none/black':
        'font-nista-grotesk text-2xs leading-none font-extrabold tracking-wide',
      // text-2xs-leading-none-bold
      'text-2xs/leading-none/bold':
        'font-nista-grotesk text-2xs leading-none font-bold tracking-wide',
      // text-2xs-leading-none-extrabold
      'text-2xs/leading-none/extrabold':
        'font-nista-grotesk text-2xs leading-none font-extrabold tracking-wide',
      // text-2xs-leading-none-extralight
      'text-2xs/leading-none/extralight':
        'font-nista-grotesk text-2xs leading-none font-thin tracking-wide',
      // text-2xs-leading-none-italic
      'text-2xs/leading-none/italic':
        'font-nista-grotesk text-2xs leading-none font-normal tracking-wide italic',
      // text-2xs-leading-none-light
      'text-2xs/leading-none/light':
        'font-nista-grotesk text-2xs leading-none font-light tracking-wide',
      // text-2xs-leading-none-medium
      'text-2xs/leading-none/medium':
        'font-nista-grotesk text-2xs leading-none font-medium tracking-wide',
      // text-2xs-leading-none-normal
      'text-2xs/leading-none/normal':
        'font-nista-grotesk text-2xs leading-none font-normal tracking-wide',
      // text-2xs-leading-none-semibold
      'text-2xs/leading-none/semibold':
        'font-nista-grotesk text-2xs leading-none font-bold tracking-wide',
      // text-2xs-leading-none-strikethrough
      'text-2xs/leading-none/strikethrough':
        'font-nista-grotesk text-2xs leading-none font-normal tracking-wide line-through',
      // text-2xs-leading-none-thin
      'text-2xs/leading-none/thin':
        'font-nista-grotesk text-2xs leading-none font-thin tracking-wide',
      // text-2xs-leading-none-underlined
      'text-2xs/leading-none/underlined':
        'font-nista-grotesk text-2xs leading-none font-normal tracking-wide underline',
      // text-2xs-leading-normal-black
      'text-2xs/leading-normal/black':
        'font-nista-grotesk text-2xs leading-2xs font-extrabold tracking-wide',
      // text-2xs-leading-normal-bold
      'text-2xs/leading-normal/bold':
        'font-nista-grotesk text-2xs leading-2xs font-bold tracking-wide',
      // text-2xs-leading-normal-extrabold
      'text-2xs/leading-normal/extrabold':
        'font-nista-grotesk text-2xs leading-2xs font-extrabold tracking-wide',
      // text-2xs-leading-normal-extralight
      'text-2xs/leading-normal/extralight':
        'font-nista-grotesk text-2xs leading-2xs font-thin tracking-wide',
      // text-2xs-leading-normal-italic
      'text-2xs/leading-normal/italic':
        'font-nista-grotesk text-2xs leading-2xs font-normal tracking-wide italic',
      // text-2xs-leading-normal-light
      'text-2xs/leading-normal/light':
        'font-nista-grotesk text-2xs leading-2xs font-light tracking-wide',
      // text-2xs-leading-normal-medium
      'text-2xs/leading-normal/medium':
        'font-nista-grotesk text-2xs leading-2xs font-medium tracking-wide',
      // text-2xs-leading-normal-normal
      'text-2xs/leading-normal/normal':
        'font-nista-grotesk text-2xs leading-2xs font-normal tracking-wide',
      // text-2xs-leading-normal-semibold
      'text-2xs/leading-normal/semibold':
        'font-nista-grotesk text-2xs leading-2xs font-bold tracking-wide',
      // text-2xs-leading-normal-strikethrough
      'text-2xs/leading-normal/strikethrough':
        'font-nista-grotesk text-2xs leading-2xs font-normal tracking-wide line-through',
      // text-2xs-leading-normal-thin
      'text-2xs/leading-normal/thin':
        'font-nista-grotesk text-2xs leading-2xs font-thin tracking-wide',
      // text-2xs-leading-normal-underlined
      'text-2xs/leading-normal/underlined':
        'font-nista-grotesk text-2xs leading-2xs font-normal tracking-wide underline',
      // text-3xl-leading-none-black
      'text-3xl/leading-none/black':
        'font-nista-grotesk text-4xl leading-none font-black tracking-wider',
      // text-3xl-leading-none-bold
      'text-3xl/leading-none/bold':
        'font-nista-grotesk text-4xl leading-none font-bold tracking-wider',
      // text-3xl-leading-none-extrabold
      'text-3xl/leading-none/extrabold':
        'font-nista-grotesk text-4xl leading-none font-extrabold tracking-wider',
      // text-3xl-leading-none-extralight
      'text-3xl/leading-none/extralight':
        'font-nista-grotesk text-4xl leading-none font-thin tracking-wider',
      // text-3xl-leading-none-italic
      'text-3xl/leading-none/italic':
        'font-nista-grotesk text-4xl leading-none font-normal tracking-wider italic',
      // text-3xl-leading-none-light
      'text-3xl/leading-none/light':
        'font-nista-grotesk text-4xl leading-none font-light tracking-wider',
      // text-3xl-leading-none-medium
      'text-3xl/leading-none/medium':
        'font-nista-grotesk text-4xl leading-none font-medium tracking-wider',
      // text-3xl-leading-none-normal
      'text-3xl/leading-none/normal':
        'font-nista-grotesk text-4xl leading-none font-normal tracking-wider',
      // text-3xl-leading-none-semibold
      'text-3xl/leading-none/semibold':
        'font-nista-grotesk text-4xl leading-none font-bold tracking-wider',
      // text-3xl-leading-none-strikethrough
      'text-3xl/leading-none/strikethrough':
        'font-nista-grotesk text-4xl leading-none font-normal tracking-wider line-through',
      // text-3xl-leading-none-thin
      'text-3xl/leading-none/thin':
        'font-nista-grotesk text-4xl leading-none font-thin tracking-wider',
      // text-3xl-leading-none-underlined
      'text-3xl/leading-none/underlined':
        'font-nista-grotesk text-4xl leading-none font-normal tracking-wider underline',
      // text-3xl-leading-normal-black
      'text-3xl/leading-normal/black':
        'font-nista-grotesk leading-3xl text-4xl font-black tracking-wide',
      // text-3xl-leading-normal-bold
      'text-3xl/leading-normal/bold':
        'font-nista-grotesk leading-3xl text-4xl font-bold tracking-wide',
      // text-3xl-leading-normal-extrabold
      'text-3xl/leading-normal/extrabold':
        'font-nista-grotesk leading-3xl text-4xl font-extrabold tracking-wide',
      // text-3xl-leading-normal-extralight
      'text-3xl/leading-normal/extralight':
        'font-nista-grotesk leading-3xl text-4xl font-thin tracking-wide',
      // text-3xl-leading-normal-italic
      'text-3xl/leading-normal/italic':
        'font-nista-grotesk leading-3xl text-4xl font-normal tracking-wide italic',
      // text-3xl-leading-normal-light
      'text-3xl/leading-normal/light':
        'font-nista-grotesk leading-3xl text-4xl font-light tracking-wide',
      // text-3xl-leading-normal-medium
      'text-3xl/leading-normal/medium':
        'font-nista-grotesk leading-3xl text-4xl font-medium tracking-wide',
      // text-3xl-leading-normal-normal
      'text-3xl/leading-normal/normal':
        'font-nista-grotesk leading-3xl text-4xl font-normal tracking-wide',
      // text-3xl-leading-normal-semibold
      'text-3xl/leading-normal/semibold':
        'font-nista-grotesk leading-3xl text-4xl font-bold tracking-wide',
      // text-3xl-leading-normal-strikethrough
      'text-3xl/leading-normal/strikethrough':
        'font-nista-grotesk leading-3xl text-4xl font-normal tracking-wide line-through',
      // text-3xl-leading-normal-thin
      'text-3xl/leading-normal/thin':
        'font-nista-grotesk leading-3xl text-4xl font-thin tracking-wide',
      // text-3xl-leading-normal-underlined
      'text-3xl/leading-normal/underlined':
        'font-nista-grotesk leading-3xl text-4xl font-normal tracking-wide underline',
      // text-4xl-leading-none-black
      'text-4xl/leading-none/black':
        'font-nista-grotesk text-6xl leading-none font-black tracking-wider',
      // text-4xl-leading-none-bold
      'text-4xl/leading-none/bold':
        'font-nista-grotesk text-6xl leading-none font-bold tracking-wider',
      // text-4xl-leading-none-extrabold
      'text-4xl/leading-none/extrabold':
        'font-nista-grotesk text-6xl leading-none font-extrabold tracking-wider',
      // text-4xl-leading-none-extralight
      'text-4xl/leading-none/extralight':
        'font-nista-grotesk text-6xl leading-none font-thin tracking-wider',
      // text-4xl-leading-none-italic
      'text-4xl/leading-none/italic':
        'font-nista-grotesk text-6xl leading-none font-normal tracking-wider italic',
      // text-4xl-leading-none-light
      'text-4xl/leading-none/light':
        'font-nista-grotesk text-6xl leading-none font-light tracking-wider',
      // text-4xl-leading-none-medium
      'text-4xl/leading-none/medium':
        'font-nista-grotesk text-6xl leading-none font-medium tracking-wider',
      // text-4xl-leading-none-normal
      'text-4xl/leading-none/normal':
        'font-nista-grotesk text-6xl leading-none font-normal tracking-wider',
      // text-4xl-leading-none-semibold
      'text-4xl/leading-none/semibold':
        'font-nista-grotesk text-6xl leading-none font-bold tracking-wider',
      // text-4xl-leading-none-strikethrough
      'text-4xl/leading-none/strikethrough':
        'font-nista-grotesk text-6xl leading-none font-normal tracking-wider line-through',
      // text-4xl-leading-none-thin
      'text-4xl/leading-none/thin':
        'font-nista-grotesk text-6xl leading-none font-thin tracking-wider',
      // text-4xl-leading-none-underlined
      'text-4xl/leading-none/underlined':
        'font-nista-grotesk text-6xl leading-none font-normal tracking-wider underline',
      // text-4xl-leading-normal-black
      'text-4xl/leading-normal/black':
        'font-nista-grotesk leading-5xl text-6xl font-black tracking-wide',
      // text-4xl-leading-normal-bold
      'text-4xl/leading-normal/bold':
        'font-nista-grotesk leading-5xl text-6xl font-bold tracking-wide',
      // text-4xl-leading-normal-extrabold
      'text-4xl/leading-normal/extrabold':
        'font-nista-grotesk leading-5xl text-6xl font-extrabold tracking-wide',
      // text-4xl-leading-normal-extralight
      'text-4xl/leading-normal/extralight':
        'font-nista-grotesk leading-5xl text-6xl font-thin tracking-wide',
      // text-4xl-leading-normal-italic
      'text-4xl/leading-normal/italic':
        'font-nista-grotesk leading-5xl text-6xl font-normal tracking-wide italic',
      // text-4xl-leading-normal-light
      'text-4xl/leading-normal/light':
        'font-nista-grotesk leading-5xl text-6xl font-light tracking-wide',
      // text-4xl-leading-normal-medium
      'text-4xl/leading-normal/medium':
        'font-nista-grotesk leading-5xl text-6xl font-medium tracking-wide',
      // text-4xl-leading-normal-normal
      'text-4xl/leading-normal/normal':
        'font-nista-grotesk leading-5xl text-6xl font-normal tracking-wide',
      // text-4xl-leading-normal-semibold
      'text-4xl/leading-normal/semibold':
        'font-nista-grotesk leading-5xl text-6xl font-bold tracking-wide',
      // text-4xl-leading-normal-strikethrough
      'text-4xl/leading-normal/strikethrough':
        'font-nista-grotesk leading-5xl text-6xl font-normal tracking-wide line-through',
      // text-4xl-leading-normal-thin
      'text-4xl/leading-normal/thin':
        'font-nista-grotesk leading-5xl text-6xl font-thin tracking-wide',
      // text-4xl-leading-normal-underlined
      'text-4xl/leading-normal/underlined':
        'font-nista-grotesk leading-5xl text-6xl font-normal tracking-wide underline',
      // text-5xl-leading-none-black
      'text-5xl/leading-none/black':
        'font-nista-grotesk text-7xl leading-none font-black tracking-wider',
      // text-5xl-leading-none-bold
      'text-5xl/leading-none/bold':
        'font-nista-grotesk text-7xl leading-none font-bold tracking-wider',
      // text-5xl-leading-none-extrabold
      'text-5xl/leading-none/extrabold':
        'font-nista-grotesk text-7xl leading-none font-extrabold tracking-wider',
      // text-5xl-leading-none-extralight
      'text-5xl/leading-none/extralight':
        'font-nista-grotesk text-7xl leading-none font-thin tracking-wider',
      // text-5xl-leading-none-italic
      'text-5xl/leading-none/italic':
        'font-nista-grotesk text-7xl leading-none font-normal tracking-wide italic',
      // text-5xl-leading-none-light
      'text-5xl/leading-none/light':
        'font-nista-grotesk text-7xl leading-none font-light tracking-wider',
      // text-5xl-leading-none-medium
      'text-5xl/leading-none/medium':
        'font-nista-grotesk text-7xl leading-none font-medium tracking-wider',
      // text-5xl-leading-none-normal
      'text-5xl/leading-none/normal':
        'font-nista-grotesk text-7xl leading-none font-normal tracking-wider',
      // text-5xl-leading-none-semibold
      'text-5xl/leading-none/semibold':
        'font-nista-grotesk text-7xl leading-none font-bold tracking-wider',
      // text-5xl-leading-none-strikethrough
      'text-5xl/leading-none/strikethrough':
        'font-nista-grotesk text-7xl leading-none font-normal tracking-wider line-through',
      // text-5xl-leading-none-thin
      'text-5xl/leading-none/thin':
        'font-nista-grotesk text-7xl leading-none font-thin tracking-wider',
      // text-5xl-leading-none-underlined
      'text-5xl/leading-none/underlined':
        'font-nista-grotesk text-7xl leading-none font-normal tracking-wider underline',
      // text-5xl-leading-normal-black
      'text-5xl/leading-normal/black':
        'font-nista-grotesk leading-6xl text-7xl font-black tracking-wide',
      // text-5xl-leading-normal-bold
      'text-5xl/leading-normal/bold':
        'font-nista-grotesk leading-6xl text-7xl font-bold tracking-wide',
      // text-5xl-leading-normal-extrabold
      'text-5xl/leading-normal/extrabold':
        'font-nista-grotesk leading-6xl text-7xl font-extrabold tracking-wide',
      // text-5xl-leading-normal-extralight
      'text-5xl/leading-normal/extralight':
        'font-nista-grotesk leading-6xl text-7xl font-thin tracking-wide',
      // text-5xl-leading-normal-italic
      'text-5xl/leading-normal/italic':
        'font-nista-grotesk leading-6xl text-7xl font-normal tracking-wide italic',
      // text-5xl-leading-normal-light
      'text-5xl/leading-normal/light':
        'font-nista-grotesk leading-6xl text-7xl font-light tracking-wide',
      // text-5xl-leading-normal-medium
      'text-5xl/leading-normal/medium':
        'font-nista-grotesk leading-6xl text-7xl font-medium tracking-wide',
      // text-5xl-leading-normal-normal
      'text-5xl/leading-normal/normal':
        'font-nista-grotesk leading-6xl text-7xl font-normal tracking-wide',
      // text-5xl-leading-normal-semibold
      'text-5xl/leading-normal/semibold':
        'font-nista-grotesk leading-6xl text-7xl font-bold tracking-wide',
      // text-5xl-leading-normal-strikethrough
      'text-5xl/leading-normal/strikethrough':
        'font-nista-grotesk leading-6xl text-7xl font-normal tracking-wide line-through',
      // text-5xl-leading-normal-thin
      'text-5xl/leading-normal/thin':
        'font-nista-grotesk leading-6xl text-7xl font-thin tracking-wide',
      // text-5xl-leading-normal-underlined
      'text-5xl/leading-normal/underlined':
        'font-nista-grotesk leading-6xl text-7xl font-normal tracking-wide underline',
      // text-6xl-leading-none-black
      'text-6xl/leading-none/black':
        'font-nista-grotesk text-8xl leading-none font-black tracking-wider',
      // text-6xl-leading-none-bold
      'text-6xl/leading-none/bold':
        'font-nista-grotesk text-8xl leading-none font-bold tracking-wider',
      // text-6xl-leading-none-extrabold
      'text-6xl/leading-none/extrabold':
        'font-nista-grotesk text-8xl leading-none font-extrabold tracking-wider',
      // text-6xl-leading-none-extralight
      'text-6xl/leading-none/extralight':
        'font-nista-grotesk text-8xl leading-none font-thin tracking-wider',
      // text-6xl-leading-none-light
      'text-6xl/leading-none/light':
        'font-nista-grotesk text-8xl leading-none font-normal tracking-wider',
      // text-6xl-leading-none-medium
      'text-6xl/leading-none/medium':
        'font-nista-grotesk text-8xl leading-none font-medium tracking-wider',
      // text-6xl-leading-none-normal
      'text-6xl/leading-none/normal':
        'font-nista-grotesk text-8xl leading-none font-normal tracking-wider',
      // text-6xl-leading-none-semibold
      'text-6xl/leading-none/semibold':
        'font-nista-grotesk text-8xl leading-none font-bold tracking-wider',
      // text-6xl-leading-none-strikethrough
      'text-6xl/leading-none/strikethrough':
        'font-nista-grotesk text-8xl leading-none font-normal tracking-wider line-through',
      // text-6xl-leading-none-thin
      'text-6xl/leading-none/thin':
        'font-nista-grotesk text-8xl leading-none font-thin tracking-wider',
      // text-6xl-leading-none-untitled
      'text-6xl/leading-none/untitled':
        'font-nista-grotesk text-8xl leading-none font-normal tracking-wider',
      // text-6xl-leading-normal-black
      'text-6xl/leading-normal/black':
        'font-nista-grotesk leading-8xl text-8xl font-black tracking-normal',
      // text-6xl-leading-normal-bold
      'text-6xl/leading-normal/bold':
        'font-nista-grotesk leading-8xl text-8xl font-bold tracking-normal',
      // text-6xl-leading-normal-extrabold
      'text-6xl/leading-normal/extrabold':
        'font-nista-grotesk leading-8xl text-8xl font-extrabold tracking-normal',
      // text-6xl-leading-normal-extralight
      'text-6xl/leading-normal/extralight':
        'font-nista-grotesk leading-8xl text-8xl font-thin tracking-normal',
      // text-6xl-leading-normal-light
      'text-6xl/leading-normal/light':
        'font-nista-grotesk leading-8xl text-8xl font-light tracking-normal',
      // text-6xl-leading-normal-medium
      'text-6xl/leading-normal/medium':
        'font-nista-grotesk leading-8xl text-8xl font-medium tracking-normal',
      // text-6xl-leading-normal-normal
      'text-6xl/leading-normal/normal':
        'font-nista-grotesk leading-8xl text-8xl font-normal tracking-normal',
      // text-6xl-leading-normal-semibold
      'text-6xl/leading-normal/semibold':
        'font-nista-grotesk leading-8xl text-8xl font-bold tracking-normal',
      // text-6xl-leading-normal-strikethrough
      'text-6xl/leading-normal/strikethrough':
        'font-nista-grotesk leading-8xl text-8xl font-normal tracking-normal line-through',
      // text-6xl-leading-normal-thin
      'text-6xl/leading-normal/thin':
        'font-nista-grotesk leading-8xl text-8xl font-thin tracking-normal',
      // text-6xl-leading-normal-underlined
      'text-6xl/leading-normal/underlined':
        'font-nista-grotesk leading-8xl text-8xl font-normal tracking-normal underline',
      // text-7xl-leading-none-black
      'text-7xl/leading-none/black':
        'font-nista-grotesk text-10xl leading-none font-black tracking-wider',
      // text-7xl-leading-none-bold
      'text-7xl/leading-none/bold':
        'font-nista-grotesk text-10xl leading-none font-bold tracking-wider',
      // text-7xl-leading-none-extrabold
      'text-7xl/leading-none/extrabold':
        'font-nista-grotesk text-10xl leading-none font-extrabold tracking-wider',
      // text-7xl-leading-none-extralight
      'text-7xl/leading-none/extralight':
        'font-nista-grotesk text-10xl leading-none font-thin tracking-wider',
      // text-7xl-leading-none-light
      'text-7xl/leading-none/light':
        'font-nista-grotesk text-10xl leading-none font-light tracking-wider',
      // text-7xl-leading-none-medium
      'text-7xl/leading-none/medium':
        'font-nista-grotesk text-10xl leading-none font-medium tracking-wider',
      // text-7xl-leading-none-normal
      'text-7xl/leading-none/normal':
        'font-nista-grotesk text-10xl leading-none font-normal tracking-wider',
      // text-7xl-leading-none-semibold
      'text-7xl/leading-none/semibold':
        'font-nista-grotesk text-10xl leading-none font-bold tracking-wider',
      // text-7xl-leading-none-strikethrough
      'text-7xl/leading-none/strikethrough':
        'font-nista-grotesk text-10xl leading-none font-normal tracking-wider line-through',
      // text-7xl-leading-none-thin
      'text-7xl/leading-none/thin':
        'font-nista-grotesk text-10xl leading-none font-thin tracking-wider',
      // text-7xl-leading-none-untitled
      'text-7xl/leading-none/untitled':
        'font-nista-grotesk text-10xl leading-none font-normal tracking-wider',
      // text-7xl-leading-normal-black
      'text-7xl/leading-normal/black':
        'font-nista-grotesk text-10xl leading-9xl font-black tracking-normal',
      // text-7xl-leading-normal-bold
      'text-7xl/leading-normal/bold':
        'font-nista-grotesk text-10xl leading-9xl font-bold tracking-normal',
      // text-7xl-leading-normal-extrabold
      'text-7xl/leading-normal/extrabold':
        'font-nista-grotesk text-10xl leading-9xl font-extrabold tracking-normal',
      // text-7xl-leading-normal-extralight
      'text-7xl/leading-normal/extralight':
        'font-nista-grotesk text-10xl leading-9xl font-thin tracking-normal',
      // text-7xl-leading-normal-light
      'text-7xl/leading-normal/light':
        'font-nista-grotesk text-10xl leading-9xl font-light tracking-normal',
      // text-7xl-leading-normal-medium
      'text-7xl/leading-normal/medium':
        'font-nista-grotesk text-10xl leading-9xl font-medium tracking-normal',
      // text-7xl-leading-normal-normal
      'text-7xl/leading-normal/normal':
        'font-nista-grotesk text-10xl leading-9xl font-normal tracking-normal',
      // text-7xl-leading-normal-semibold
      'text-7xl/leading-normal/semibold':
        'font-nista-grotesk text-10xl leading-9xl font-bold tracking-normal',
      // text-7xl-leading-normal-strikethrough
      'text-7xl/leading-normal/strikethrough':
        'font-nista-grotesk text-10xl leading-9xl font-normal tracking-normal line-through',
      // text-7xl-leading-normal-thin
      'text-7xl/leading-normal/thin':
        'font-nista-grotesk text-10xl leading-9xl font-thin tracking-normal',
      // text-7xl-leading-normal-underlined
      'text-7xl/leading-normal/underlined':
        'font-nista-grotesk text-10xl leading-9xl font-normal tracking-normal underline',
      // text-8xl-leading-none-black
      'text-8xl/leading-none/black':
        'font-nista-grotesk text-12xl leading-none font-black tracking-wider',
      // text-8xl-leading-none-bold
      'text-8xl/leading-none/bold':
        'font-nista-grotesk text-12xl leading-none font-bold tracking-wider',
      // text-8xl-leading-none-extrabold
      'text-8xl/leading-none/extrabold':
        'font-nista-grotesk text-12xl leading-none font-extrabold tracking-wider',
      // text-8xl-leading-none-extralight
      'text-8xl/leading-none/extralight':
        'font-nista-grotesk text-12xl leading-none font-thin tracking-wider',
      // text-8xl-leading-none-light
      'text-8xl/leading-none/light':
        'font-nista-grotesk text-12xl leading-none font-light tracking-wider',
      // text-8xl-leading-none-medium
      'text-8xl/leading-none/medium':
        'font-nista-grotesk text-12xl leading-none font-medium tracking-wider',
      // text-8xl-leading-none-normal
      'text-8xl/leading-none/normal':
        'font-nista-grotesk text-12xl leading-none font-normal tracking-wider',
      // text-8xl-leading-none-semibold
      'text-8xl/leading-none/semibold':
        'font-nista-grotesk text-12xl leading-none font-bold tracking-wider',
      // text-8xl-leading-none-strikethrough
      'text-8xl/leading-none/strikethrough':
        'font-nista-grotesk text-12xl leading-none font-normal tracking-wider line-through',
      // text-8xl-leading-none-thin
      'text-8xl/leading-none/thin':
        'font-nista-grotesk text-12xl leading-none font-thin tracking-wider',
      // text-8xl-leading-none-underlined
      'text-8xl/leading-none/underlined':
        'font-nista-grotesk text-12xl leading-none font-normal tracking-wider underline',
      // text-8xl-leading-normal-black
      'text-8xl/leading-normal/black':
        'font-nista-grotesk text-12xl leading-11xl font-black tracking-tight',
      // text-8xl-leading-normal-bold
      'text-8xl/leading-normal/bold':
        'font-nista-grotesk text-12xl leading-11xl font-bold tracking-tight',
      // text-8xl-leading-normal-extrabold
      'text-8xl/leading-normal/extrabold':
        'font-nista-grotesk text-12xl leading-11xl font-extrabold tracking-tight',
      // text-8xl-leading-normal-extralight
      'text-8xl/leading-normal/extralight':
        'font-nista-grotesk text-12xl leading-11xl font-thin tracking-tight',
      // text-8xl-leading-normal-light
      'text-8xl/leading-normal/light':
        'font-nista-grotesk text-12xl leading-11xl font-light tracking-tight',
      // text-8xl-leading-normal-medium
      'text-8xl/leading-normal/medium':
        'font-nista-grotesk text-12xl leading-11xl font-medium tracking-tight',
      // text-8xl-leading-normal-normal
      'text-8xl/leading-normal/normal':
        'font-nista-grotesk text-12xl leading-11xl font-normal tracking-tight',
      // text-8xl-leading-normal-semibold
      'text-8xl/leading-normal/semibold':
        'font-nista-grotesk text-12xl leading-11xl font-bold tracking-tight',
      // text-8xl-leading-normal-strikethrough
      'text-8xl/leading-normal/strikethrough':
        'font-nista-grotesk text-12xl leading-11xl font-normal tracking-tight line-through',
      // text-8xl-leading-normal-thin
      'text-8xl/leading-normal/thin':
        'font-nista-grotesk text-12xl leading-11xl font-thin tracking-tight',
      // text-8xl-leading-normal-underlined
      'text-8xl/leading-normal/underlined':
        'font-nista-grotesk text-12xl leading-11xl font-normal tracking-tight underline',
      // text-9xl-leading-none-black
      'text-9xl/leading-none/black':
        'font-nista-grotesk text-13xl leading-none font-black tracking-wider',
      // text-9xl-leading-none-bold
      'text-9xl/leading-none/bold':
        'font-nista-grotesk text-13xl leading-none font-bold tracking-wider',
      // text-9xl-leading-none-extrabold
      'text-9xl/leading-none/extrabold':
        'font-nista-grotesk text-13xl leading-none font-extrabold tracking-wider',
      // text-9xl-leading-none-extralight
      'text-9xl/leading-none/extralight':
        'font-nista-grotesk text-13xl leading-none font-thin tracking-wider',
      // text-9xl-leading-none-light
      'text-9xl/leading-none/light':
        'font-nista-grotesk text-13xl leading-none font-light tracking-wider',
      // text-9xl-leading-none-medium
      'text-9xl/leading-none/medium':
        'font-nista-grotesk text-13xl leading-none font-medium tracking-wider',
      // text-9xl-leading-none-normal
      'text-9xl/leading-none/normal':
        'font-nista-grotesk text-13xl leading-none font-normal tracking-wider',
      // text-9xl-leading-none-semibold
      'text-9xl/leading-none/semibold':
        'font-nista-grotesk text-13xl leading-none font-bold tracking-wider',
      // text-9xl-leading-none-strikethrough
      'text-9xl/leading-none/strikethrough':
        'font-nista-grotesk text-13xl leading-none font-normal tracking-wider line-through',
      // text-9xl-leading-none-thin
      'text-9xl/leading-none/thin':
        'font-nista-grotesk text-13xl leading-none font-thin tracking-wider',
      // text-9xl-leading-none-underlined
      'text-9xl/leading-none/underlined':
        'font-nista-grotesk text-13xl leading-none font-normal tracking-wider underline',
      // text-9xl-leading-normal-black
      'text-9xl/leading-normal/black':
        'font-nista-grotesk text-13xl leading-13xl font-black tracking-tight',
      // text-9xl-leading-normal-bold
      'text-9xl/leading-normal/bold':
        'font-nista-grotesk text-13xl leading-13xl font-bold tracking-tight',
      // text-9xl-leading-normal-extrabold
      'text-9xl/leading-normal/extrabold':
        'font-nista-grotesk text-13xl leading-13xl font-extrabold tracking-tight',
      // text-9xl-leading-normal-extralight
      'text-9xl/leading-normal/extralight':
        'font-nista-grotesk text-13xl leading-13xl font-thin tracking-tight',
      // text-9xl-leading-normal-light
      'text-9xl/leading-normal/light':
        'font-nista-grotesk text-13xl leading-13xl font-light tracking-tight',
      // text-9xl-leading-normal-medium
      'text-9xl/leading-normal/medium':
        'font-nista-grotesk text-13xl leading-13xl font-medium tracking-tight',
      // text-9xl-leading-normal-normal
      'text-9xl/leading-normal/normal':
        'font-nista-grotesk text-13xl leading-13xl font-normal tracking-tight',
      // text-9xl-leading-normal-semibold
      'text-9xl/leading-normal/semibold':
        'font-nista-grotesk text-13xl leading-13xl font-bold tracking-tight',
      // text-9xl-leading-normal-strikethrough
      'text-9xl/leading-normal/strikethrough':
        'font-nista-grotesk text-13xl leading-13xl font-normal tracking-tight line-through',
      // text-9xl-leading-normal-thin
      'text-9xl/leading-normal/thin':
        'font-nista-grotesk text-13xl leading-13xl font-thin tracking-tight',
      // text-9xl-leading-normal-underlined
      'text-9xl/leading-normal/underlined':
        'font-nista-grotesk text-13xl leading-13xl font-normal tracking-tight underline',
      // text-base-leading-none-black
      'text-base/leading-none/black':
        'font-nista-grotesk text-base leading-none font-black tracking-wider',
      // text-base-leading-none-bold
      'text-base/leading-none/bold':
        'font-nista-grotesk text-base leading-none font-bold tracking-wider',
      // text-base-leading-none-extrabold
      'text-base/leading-none/extrabold':
        'font-nista-grotesk text-base leading-none font-extrabold tracking-wider',
      // text-base-leading-none-extralight
      'text-base/leading-none/extralight':
        'font-nista-grotesk text-base leading-none font-thin tracking-wider',
      // text-base-leading-none-italic
      'text-base/leading-none/italic':
        'font-nista-grotesk text-base leading-none font-normal tracking-wider italic',
      // text-base-leading-none-light
      'text-base/leading-none/light':
        'font-nista-grotesk text-base leading-none font-light tracking-wider',
      // text-base-leading-none-medium
      'text-base/leading-none/medium':
        'font-nista-grotesk text-base leading-none font-medium tracking-wider',
      // text-base-leading-none-normal
      'text-base/leading-none/normal':
        'font-nista-grotesk text-base leading-none font-normal tracking-wider',
      // text-base-leading-none-semibold
      'text-base/leading-none/semibold':
        'font-nista-grotesk text-base leading-none font-bold tracking-wider',
      // text-base-leading-none-strikethrough
      'text-base/leading-none/strikethrough':
        'font-nista-grotesk text-base leading-none font-normal tracking-wider line-through',
      // text-base-leading-none-thin
      'text-base/leading-none/thin':
        'font-nista-grotesk text-base leading-none font-thin tracking-wider',
      // text-base-leading-none-underlined
      'text-base/leading-none/underlined':
        'font-nista-grotesk text-base leading-none font-normal tracking-wider underline',
      // text-base-leading-normal-black
      'text-base/leading-normal/black':
        'font-nista-grotesk leading-base text-base font-black tracking-wide',
      // text-base-leading-normal-bold
      'text-base/leading-normal/bold':
        'font-nista-grotesk leading-base text-base font-bold tracking-wide',
      // text-base-leading-normal-extrabold
      'text-base/leading-normal/extrabold':
        'font-nista-grotesk leading-base text-base font-extrabold tracking-wide',
      // text-base-leading-normal-extralight
      'text-base/leading-normal/extralight':
        'font-nista-grotesk leading-base text-base font-thin tracking-wide',
      // text-base-leading-normal-italic
      'text-base/leading-normal/italic':
        'font-nista-grotesk leading-base text-base font-normal tracking-wide italic',
      // text-base-leading-normal-light
      'text-base/leading-normal/light':
        'font-nista-grotesk leading-base text-base font-light tracking-wide',
      // text-base-leading-normal-medium
      'text-base/leading-normal/medium':
        'font-nista-grotesk leading-base text-base font-medium tracking-wide',
      // text-base-leading-normal-normal
      'text-base/leading-normal/normal':
        'font-nista-grotesk leading-base text-base font-normal tracking-wide',
      // text-base-leading-normal-semibold
      'text-base/leading-normal/semibold':
        'font-nista-grotesk leading-base text-base font-bold tracking-wide',
      // text-base-leading-normal-strikethrough
      'text-base/leading-normal/strikethrough':
        'font-nista-grotesk leading-base text-base font-normal tracking-wide line-through',
      // text-base-leading-normal-thin
      'text-base/leading-normal/thin':
        'font-nista-grotesk leading-base text-base font-thin tracking-wide',
      // text-base-leading-normal-underlined
      'text-base/leading-normal/underlined':
        'font-nista-grotesk leading-base text-base font-normal tracking-wide underline',
      // text-base-leading-normal-underlined-(medium)
      'text/base/leading/normal/underlined/(medium)':
        'font-nista-grotesk leading-base text-base font-medium tracking-wide underline',
      // text-lg-leading-none-black
      'text-lg/leading-none/black':
        'font-nista-grotesk text-lg leading-none font-black tracking-wider',
      // text-lg-leading-none-bold
      'text-lg/leading-none/bold':
        'font-nista-grotesk text-lg leading-none font-bold tracking-wider',
      // text-lg-leading-none-extrabold
      'text-lg/leading-none/extrabold':
        'font-nista-grotesk text-lg leading-none font-extrabold tracking-wider',
      // text-lg-leading-none-extralight
      'text-lg/leading-none/extralight':
        'font-nista-grotesk text-lg leading-none font-thin tracking-wider',
      // text-lg-leading-none-italic
      'text-lg/leading-none/italic':
        'font-nista-grotesk text-lg leading-none font-normal tracking-wider italic',
      // text-lg-leading-none-light
      'text-lg/leading-none/light':
        'font-nista-grotesk text-lg leading-none font-light tracking-wider',
      // text-lg-leading-none-medium
      'text-lg/leading-none/medium':
        'font-nista-grotesk text-lg leading-none font-medium tracking-wider',
      // text-lg-leading-none-normal
      'text-lg/leading-none/normal':
        'font-nista-grotesk text-lg leading-none font-normal tracking-wider',
      // text-lg-leading-none-semibold
      'text-lg/leading-none/semibold':
        'font-nista-grotesk text-lg leading-none font-bold tracking-wider',
      // text-lg-leading-none-strikethrough
      'text-lg/leading-none/strikethrough':
        'font-nista-grotesk text-lg leading-none font-normal tracking-wider line-through',
      // text-lg-leading-none-thin
      'text-lg/leading-none/thin':
        'font-nista-grotesk text-lg leading-none font-thin tracking-wider',
      // text-lg-leading-none-underlined
      'text-lg/leading-none/underlined':
        'font-nista-grotesk text-lg leading-none font-normal tracking-wider underline',
      // text-lg-leading-normal-black
      'text-lg/leading-normal/black':
        'font-nista-grotesk leading-lg text-lg font-black tracking-wide',
      // text-lg-leading-normal-bold
      'text-lg/leading-normal/bold':
        'font-nista-grotesk leading-lg text-lg font-bold tracking-wide',
      // text-lg-leading-normal-extrabold
      'text-lg/leading-normal/extrabold':
        'font-nista-grotesk leading-lg text-lg font-extrabold tracking-wide',
      // text-lg-leading-normal-extralight
      'text-lg/leading-normal/extralight':
        'font-nista-grotesk leading-lg text-lg font-thin tracking-wide',
      // text-lg-leading-normal-italic
      'text-lg/leading-normal/italic':
        'font-nista-grotesk leading-lg text-lg font-normal tracking-wide italic',
      // text-lg-leading-normal-light
      'text-lg/leading-normal/light':
        'font-nista-grotesk leading-lg text-lg font-light tracking-wide',
      // text-lg-leading-normal-medium
      'text-lg/leading-normal/medium':
        'font-nista-grotesk leading-lg text-lg font-medium tracking-wide',
      // text-lg-leading-normal-normal
      'text-lg/leading-normal/normal':
        'font-nista-grotesk leading-lg text-lg font-normal tracking-wide',
      // text-lg-leading-normal-semibold
      'text-lg/leading-normal/semibold':
        'font-nista-grotesk leading-lg text-lg font-bold tracking-wide',
      // text-lg-leading-normal-strikethrough
      'text-lg/leading-normal/strikethrough':
        'font-nista-grotesk leading-lg text-lg font-normal tracking-wide line-through',
      // text-lg-leading-normal-thin
      'text-lg/leading-normal/thin':
        'font-nista-grotesk leading-lg text-lg font-thin tracking-wide',
      // text-lg-leading-normal-underlined
      'text-lg/leading-normal/underlined':
        'font-nista-grotesk leading-lg text-lg font-normal tracking-wide underline',
      // text-sm-leading-none-black
      'text-sm/leading-none/black':
        'font-nista-grotesk text-sm leading-none font-extrabold tracking-wider',
      // text-sm-leading-none-bold
      'text-sm/leading-none/bold':
        'font-nista-grotesk text-sm leading-none font-bold tracking-wider',
      // text-sm-leading-none-extrabold
      'text-sm/leading-none/extrabold':
        'font-nista-grotesk text-sm leading-none font-extrabold tracking-wider',
      // text-sm-leading-none-extralight
      'text-sm/leading-none/extralight':
        'font-nista-grotesk text-sm leading-none font-thin tracking-wider',
      // text-sm-leading-none-italic
      'text-sm/leading-none/italic':
        'font-nista-grotesk text-sm leading-none font-normal tracking-wider italic',
      // text-sm-leading-none-light
      'text-sm/leading-none/light':
        'font-nista-grotesk text-sm leading-none font-light tracking-wider',
      // text-sm-leading-none-medium
      'text-sm/leading-none/medium':
        'font-nista-grotesk text-sm leading-none font-medium tracking-wider',
      // text-sm-leading-none-normal
      'text-sm/leading-none/normal':
        'font-nista-grotesk text-sm leading-none font-normal tracking-wider',
      // text-sm-leading-none-semibold
      'text-sm/leading-none/semibold':
        'font-nista-grotesk text-sm leading-none font-bold tracking-wider',
      // text-sm-leading-none-strikethrough
      'text-sm/leading-none/strikethrough':
        'font-nista-grotesk text-sm leading-none font-normal tracking-wider line-through',
      // text-sm-leading-none-thin
      'text-sm/leading-none/thin':
        'font-nista-grotesk text-sm leading-none font-thin tracking-wider',
      // text-sm-leading-none-underlined
      'text-sm/leading-none/underlined':
        'font-nista-grotesk text-sm leading-none font-normal tracking-wider underline',
      // text-sm-leading-normal-black
      'text-sm/leading-normal/black':
        'font-nista-grotesk leading-sm text-sm font-black tracking-wide',
      // text-sm-leading-normal-bold
      'text-sm/leading-normal/bold':
        'font-nista-grotesk leading-sm text-sm font-bold tracking-wide',
      // text-sm-leading-normal-extrabold
      'text-sm/leading-normal/extrabold':
        'font-nista-grotesk leading-sm text-sm font-extrabold tracking-wide',
      // text-sm-leading-normal-extralight
      'text-sm/leading-normal/extralight':
        'font-nista-grotesk leading-sm text-sm font-thin tracking-wide',
      // text-sm-leading-normal-italic
      'text-sm/leading-normal/italic':
        'font-nista-grotesk leading-sm text-sm font-normal tracking-wide italic',
      // text-sm-leading-normal-light
      'text-sm/leading-normal/light':
        'font-nista-grotesk leading-sm text-sm font-light tracking-wide',
      // text-sm-leading-normal-medium
      'text-sm/leading-normal/medium':
        'font-nista-grotesk leading-sm text-sm font-medium tracking-wide',
      // text-sm-leading-normal-normal
      'text-sm/leading-normal/normal':
        'font-nista-grotesk leading-sm text-sm font-normal tracking-wide',
      // text-sm-leading-normal-semibold
      'text-sm/leading-normal/semibold':
        'font-nista-grotesk leading-sm text-sm font-bold tracking-wide',
      // text-sm-leading-normal-strikethrough
      'text-sm/leading-normal/strikethrough':
        'font-nista-grotesk leading-sm text-sm font-normal tracking-wide line-through',
      // text-sm-leading-normal-thin
      'text-sm/leading-normal/thin':
        'font-nista-grotesk leading-sm text-sm font-thin tracking-wide',
      // text-sm-leading-normal-underlined
      'text-sm/leading-normal/underlined':
        'font-nista-grotesk leading-sm text-sm font-normal tracking-wide underline',
      // text-sm-leading-normal-underlined-(medium)
      'text/sm/leading/normal/underlined/(medium)':
        'font-nista-grotesk leading-sm text-sm font-medium tracking-wide underline',
      // text-xl-leading-none-black
      'text-xl/leading-none/black':
        'font-nista-grotesk text-xl leading-none font-black tracking-wider',
      // text-xl-leading-none-bold
      'text-xl/leading-none/bold':
        'font-nista-grotesk text-xl leading-none font-bold tracking-wider',
      // text-xl-leading-none-extrabold
      'text-xl/leading-none/extrabold':
        'font-nista-grotesk text-xl leading-none font-extrabold tracking-wider',
      // text-xl-leading-none-extralight
      'text-xl/leading-none/extralight':
        'font-nista-grotesk text-xl leading-none font-thin tracking-wider',
      // text-xl-leading-none-italic
      'text-xl/leading-none/italic':
        'font-nista-grotesk text-xl leading-none font-normal tracking-wider italic',
      // text-xl-leading-none-light
      'text-xl/leading-none/light':
        'font-nista-grotesk text-xl leading-none font-light tracking-wider',
      // text-xl-leading-none-medium
      'text-xl/leading-none/medium':
        'font-nista-grotesk text-xl leading-none font-medium tracking-wider',
      // text-xl-leading-none-normal
      'text-xl/leading-none/normal':
        'font-nista-grotesk text-xl leading-none font-normal tracking-wider',
      // text-xl-leading-none-semibold
      'text-xl/leading-none/semibold':
        'font-nista-grotesk text-xl leading-none font-bold tracking-wider',
      // text-xl-leading-none-strikethrough
      'text-xl/leading-none/strikethrough':
        'font-nista-grotesk text-xl leading-none font-normal tracking-wider line-through',
      // text-xl-leading-none-thin
      'text-xl/leading-none/thin':
        'font-nista-grotesk text-xl leading-none font-thin tracking-wider',
      // text-xl-leading-none-underlined
      'text-xl/leading-none/underlined':
        'font-nista-grotesk text-xl leading-none font-normal tracking-wider underline',
      // text-xl-leading-normal-black
      'text-xl/leading-normal/black':
        'font-nista-grotesk leading-lg text-xl font-black tracking-wide',
      // text-xl-leading-normal-bold
      'text-xl/leading-normal/bold':
        'font-nista-grotesk leading-lg text-xl font-bold tracking-wide',
      // text-xl-leading-normal-extrabold
      'text-xl/leading-normal/extrabold':
        'font-nista-grotesk leading-lg text-xl font-extrabold tracking-wide',
      // text-xl-leading-normal-extralight
      'text-xl/leading-normal/extralight':
        'font-nista-grotesk leading-lg text-xl font-thin tracking-wide',
      // text-xl-leading-normal-italic
      'text-xl/leading-normal/italic':
        'font-nista-grotesk leading-lg text-xl font-normal tracking-wide italic',
      // text-xl-leading-normal-light
      'text-xl/leading-normal/light':
        'font-nista-grotesk leading-lg text-xl font-light tracking-wide',
      // text-xl-leading-normal-medium
      'text-xl/leading-normal/medium':
        'font-nista-grotesk leading-lg text-xl font-medium tracking-wide',
      // text-xl-leading-normal-normal
      'text-xl/leading-normal/normal':
        'font-nista-grotesk leading-lg text-xl font-normal tracking-wide',
      // text-xl-leading-normal-semibold
      'text-xl/leading-normal/semibold':
        'font-nista-grotesk leading-lg text-xl font-bold tracking-wide',
      // text-xl-leading-normal-strikethrough
      'text-xl/leading-normal/strikethrough':
        'font-nista-grotesk leading-lg text-xl font-normal tracking-wide line-through',
      // text-xl-leading-normal-thin
      'text-xl/leading-normal/thin':
        'font-nista-grotesk leading-lg text-xl font-thin tracking-wide',
      // text-xl-leading-normal-underlined
      'text-xl/leading-normal/underlined':
        'font-nista-grotesk leading-lg text-xl font-normal tracking-wide underline',
      // text-xs-leading-none-black
      'text-xs/leading-none/black':
        'font-nista-grotesk text-xs leading-none font-black tracking-wider',
      // text-xs-leading-none-bold
      'text-xs/leading-none/bold':
        'font-nista-grotesk text-xs leading-none font-bold tracking-wider',
      // text-xs-leading-none-extrabold
      'text-xs/leading-none/extrabold':
        'font-nista-grotesk text-xs leading-none font-extrabold tracking-wider',
      // text-xs-leading-none-extralight
      'text-xs/leading-none/extralight':
        'font-nista-grotesk text-xs leading-none font-thin tracking-wider',
      // text-xs-leading-none-italic
      'text-xs/leading-none/italic':
        'font-nista-grotesk text-xs leading-none font-normal tracking-wider italic',
      // text-xs-leading-none-light
      'text-xs/leading-none/light':
        'font-nista-grotesk text-xs leading-none font-light tracking-wider',
      // text-xs-leading-none-medium
      'text-xs/leading-none/medium':
        'font-nista-grotesk text-xs leading-none font-medium tracking-wider',
      // text-xs-leading-none-normal
      'text-xs/leading-none/normal':
        'font-nista-grotesk text-xs leading-none font-normal tracking-normal',
      // text-xs-leading-none-semibold
      'text-xs/leading-none/semibold':
        'font-nista-grotesk text-xs leading-none font-bold tracking-wider',
      // text-xs-leading-none-strikethrough
      'text-xs/leading-none/strikethrough':
        'font-nista-grotesk text-xs leading-none font-normal tracking-wider line-through',
      // text-xs-leading-none-thin
      'text-xs/leading-none/thin':
        'font-nista-grotesk text-xs leading-none font-thin tracking-wider',
      // text-xs-leading-none-underlined
      'text-xs/leading-none/underlined':
        'font-nista-grotesk text-xs leading-none font-normal tracking-wider underline',
      // text-xs-leading-normal-black
      'text-xs/leading-normal/black':
        'font-nista-grotesk leading-xs text-xs font-black tracking-wide',
      // text-xs-leading-normal-bold
      'text-xs/leading-normal/bold':
        'font-nista-grotesk leading-xs text-xs font-bold tracking-wide',
      // text-xs-leading-normal-extrabold
      'text-xs/leading-normal/extrabold':
        'font-nista-grotesk leading-xs text-xs font-extrabold tracking-wide',
      // text-xs-leading-normal-extralight
      'text-xs/leading-normal/extralight':
        'font-nista-grotesk leading-xs text-xs font-thin tracking-wide',
      // text-xs-leading-normal-italic
      'text-xs/leading-normal/italic':
        'font-nista-grotesk leading-xs text-xs font-normal tracking-wide italic',
      // text-xs-leading-normal-light
      'text-xs/leading-normal/light':
        'font-nista-grotesk leading-xs text-xs font-light tracking-wide',
      // text-xs-leading-normal-medium
      'text-xs/leading-normal/medium':
        'font-nista-grotesk leading-xs text-xs font-medium tracking-wide',
      // text-xs-leading-normal-normal
      'text-xs/leading-normal/normal':
        'font-nista-grotesk leading-xs text-xs font-normal tracking-wide',
      // text-xs-leading-normal-semibold
      'text-xs/leading-normal/semibold':
        'font-nista-grotesk leading-xs text-xs font-bold tracking-wide',
      // text-xs-leading-normal-strikethrough
      'text-xs/leading-normal/strikethrough':
        'font-nista-grotesk leading-xs text-xs font-normal tracking-wide line-through',
      // text-xs-leading-normal-thin
      'text-xs/leading-normal/thin':
        'font-nista-grotesk leading-xs text-xs font-thin tracking-wide',
      // text-xs-leading-normal-underlined
      'text-xs/leading-normal/underlined':
        'font-nista-grotesk leading-xs text-xs font-normal tracking-wide underline',
      // title-lg-leading-8-medium
      'title-lg/leading-8/medium':
        'font-nista-grotesk leading-2xl text-2xl font-medium tracking-wide',
      // title-md-leading-7-medium
      'title-md/leading-7/medium': 'font-nista-grotesk leading-lg text-xl font-medium tracking-wide'
    }
  }
});
